import axios from 'axios';
import api from './api';

export default {
    list(payload) {
        return axios.get('[API]/canvas/list', payload);
    },
    fetch(canvasId) {
        return axios.get('[API]/canvas/fetch/' + canvasId);
    },
    update(payload, canvasId = null) {
        return axios.put('[API]/canvas/update', { canvasId, ...payload });
    },
    delete(canvasId) {
        return axios.delete('[API]/canvas/delete/' + canvasId);
    },
};
